<template>  
    <div>
        <v-tooltip bottom dark>
            <template #activator='data'>
                <v-btn large text icon>
                    <v-icon medium="" @click="form.create = true" color="success" v-on="data.on">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>nieuw formulier</span>
        </v-tooltip>     

        <dialog-create-form></dialog-create-form>
                
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["form"]),
    valid() {
      if (
        (this.$store.state.app.form.email != "" ||
          this.$store.state.app.form.email === undefined) &&
        (this.$store.state.app.form.phone != "" ||
          this.$store.state.app.form.phone === undefined)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

